import script from "./TwoFactorSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoFactorSettings.vue?vue&type=script&setup=true&lang=js"

import "./TwoFactorSettings.vue?vue&type=style&index=0&id=ed464384&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed464384"]])

export default __exports__